module.exports = __webpack_public_path__ + "static/img/4949_phase_function_Paper_Points.0eeddc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4949_phase_function_Paper_Points.png
// module id = yG/6
// module chunks = 0